<!-- 位度系统对接 GPS定位信息 -->
<template>
  <dev>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange" :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
  </dev>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {getList, add, update, remove, getDetail} from "./api";
import {searchTimeConfig} from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: {getList, add, update, remove, getDetail},
      infoCardData: [], // 卡片数据
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: '设备ID',
            prop: 'deviceId',
          },
          {
            label: '设备标签ID编码',
            prop: 'tagId',
            search: true,
            rules: [
              {required: true, message: '设备标签ID不能为空', trigger: 'blur'},
            ],
          },
          {
            label: '数据包头',
            prop: 'packetHeader',
          },
          {
            label: 'UTC时间',
            prop: 'utcTime',
            rules: [
              {required: true, message: 'UTC时间不能为空', trigger: 'blur'},
              {
                pattern: /^([0-1][0-9]|2[0-3])([0-5][0-9])([0-5][0-9])\.(\d{3})$/,
                message: 'UTC时间格式必须为HHmmss.SSS (例: 123456.789)',
                trigger: 'blur'
              }
            ],
            search: false,
            placeholder: '输入格式: HHmmss.SSS (例: 123456.789)'
          },
          {
            label: '纬度',
            prop: 'latitude',
            type: 'number',
            precision: 8,
            rules: [
              {required: true, message: '纬度不能为空', trigger: 'blur'}
            ]
          },

          {
            label: '南北纬指示',
            prop: 'nsIndicator',
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=ns_indicator",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '南北纬指示不能为空', trigger: 'change'}
            ]
          },
          {
            label: '经度',
            prop: 'longitude',
            type: 'number',
            precision: 8,
            rules: [
              {required: true, message: '经度不能为空', trigger: 'blur'}
            ]
          },
          {
            label: '东西经指示',
            prop: 'ewIndicator',
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=ew_indicator",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '东西经指示不能为空', trigger: 'change'}
            ]
          },
          {
            label: '定位状态',
            prop: 'positionStatus',
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=position_status",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择定位状态', trigger: 'change'}
            ],
          },
          {
            label: '卫星数量',
            prop: 'satelliteCount',
            type: 'number',
          },
          {
            label: '水平精度因子',
            prop: 'hdop',
            type: 'number',
            precision: 2,
            min: 0.5,
            max: 99.9
          },
          {
            label: '海拔高度(米)',
            prop: 'altitude',
            type: 'number',
            precision: 3,
            min: -9999.9,
            max: 9999.9
          },
          {
            label: '高度单位(米)',
            prop: 'altitudeUnit',
            type: 'select',
            dicData: [
              {label: '米', value: 'M'}
            ],
            value: 'M'
          },
          {
            label: '水平高度(米)',
            prop: 'geoidalSeparation',
            type: 'number',
            precision: 3
          },
          {
            label: '分离单位(米)',
            prop: 'separationUnit',
            type: 'select',
            dicData: [
              {label: '米', value: 'M'}
            ],
            value: 'M'
          },
          {
            label: '差分时间(秒)',
            prop: 'differentialSeconds',
            type: 'number',
            precision: 1
          },
          {
            label: '差分站ID号',
            prop: 'differentialStationId',
            type: 'number',
            min: 0,
            max: 1023
          },
          {
            label: '校验值',
            prop: 'checksum',
          },
          {
            label: '电池电量',
            prop: 'powerLevel',
            type: 'number',
            min: 0,
            max: 100
          },
          {
            label: '信号强度',
            prop: 'signalStrength',
            type: 'number',
            min: 0,
            max: 255
          },
          {
            label: '服务器接收时间',
            prop: 'serverTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 120,
            // search: true,
            // searchRange: true,
            rules: [
              {required: true, message: '服务器接收时间不能为空', trigger: 'change'}
            ]
          },
          {
            label: '备注',
            prop: 'remark',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
            rules: [
              {max: 500, message: '备注不能超过500个字符', trigger: 'blur'}
            ]
          },
          {
            label: "状态",
            prop: "status",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=status_flag",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择状态', trigger: 'change'}
            ],
            value: 1
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            search: false,
          },
        ]
      },
    }
  }
}
</script>
<style scoped lang="scss">
</style>
